/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.openai.integration.rpc.AppSettingsRpc
 */

export const installRpc = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'z-dmJq6t5IZjvrSLmLLPi0Uk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallRpc = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'uninstall',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABjvrSLmLLPi0Uk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertApiKeyRpc = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: 'W8Fv60z6eU9g9V5a4HKmfkUk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateResponseRpc = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'generateResponse',
  auth: 'app',
  fingerprint: 'dUQasEiJHi25k65gAtEHx0Uk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateImageRpc = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'generateImage',
  auth: 'app',
  fingerprint: 'rfCQI9Fq77XZ7XU3ArvPmUUk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};